/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CRR_CREDIT_SITUATION_ITEM = {
  id: 'credit_situation',
  screenId: 'fin-crr-credit-situation',
  label: 'Situación crediticia',
  description: 'Consulta BCRA por CUIT de clientes o proveedores.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás en la Central de Deudores del BCRA la situación crediticia de una persona o empresa antes de vender a cuenta corriente o aceptar un cheque.',
      },
      {
        title: 'Paso 1 — Ingresar CUIT',
        fields: [
          {
            label: 'CUIT / CUIL / CDI',
            description: '11 dígitos sin guiones. El sistema valida el número; cuando es correcto consulta automáticamente al Banco Central (no hay botón «Consultar»).',
          },
        ],
        paragraphs: [
          'Mientras escribís ves cuántos dígitos faltan o si el CUIT no es válido.',
          'La consulta pasa por el servidor de pymego (el BCRA no permite consultas directas desde el navegador).',
        ],
      },
      {
        title: 'Paso 2 — Datos del sujeto',
        bullets: [
          'Si hay resultados, arriba ves la denominación y el CUIT/CUIL/CDI consultado.',
          'Si no hay deudas registradas, aparece un mensaje indicándolo.',
        ],
      },
      {
        title: 'Paso 3 — Situación de deudas',
        intro: 'Por cada período informado ves tarjetas por entidad financiera:',
        bullets: [
          'Situación 1 — normal.',
          'Situación 2 — riesgo bajo / seguimiento especial.',
          'Situación 3 — riesgo medio / con problemas.',
          'Situación 4 — riesgo alto.',
          'Situación 5 — irrecuperable.',
          'En cada tarjeta: monto adeudado, días de atraso (si aplica), fecha desde situación 1 y avisos (refinanciaciones, situación jurídica, proceso judicial, etc.).',
        ],
        paragraphs: [
          'El BCRA informa los montos en miles de pesos; acá se muestran convertidos a pesos.',
        ],
      },
      {
        title: 'Paso 4 — Cheques rechazados',
        bullets: [
          'En la misma pantalla, debajo de las deudas, se listan los cheques rechazados informados al BCRA para ese CUIT.',
          'Agrupados por causal; columnas: N° cheque, fecha rechazo, monto, fecha pago, multa y empresa.',
          'Si no hay rechazos registrados, aparece un mensaje en verde.',
        ],
      },
      {
        title: 'Si hay error',
        paragraphs: [
          'Puede fallar si el servicio del BCRA no responde o hay problemas de conexión. Reintentá en unos minutos o recargá la página (Ctrl+F5) si el servidor no respondió.',
        ],
      },
    ],
  },
}
